module.exports = __webpack_public_path__ + "img/3000.7c73be2d.jpg";